import { Global } from '@emotion/react'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { isNil } from 'ramda'

import type { Article, Category } from '@twisto/api-cms'

import {
  ArticleComponents,
  CategoryBreadcrumbs,
  CategoryContentNavigation,
  CategoryLayout,
  CategoryPaper,
  ShortAnswer,
  TableOfContent,
} from '../../components'

import * as styles from './article-view.styles'

type Props = {
  article: Article
  category: Category
}

export const ArticleView = ({ article, category }: Props) => (
  <>
    {/* Adding scroll behavior to Globals styles */}
    <Global styles={styles.article} />
    <CategoryLayout
      breadcrumbs={
        <CategoryBreadcrumbs
          category={
            {
              name: category.name,
              parent: category.parent,
              path: category.path,
            } as Category
          }
        />
      }
      contentNavigation={
        <CategoryContentNavigation parent={category.parent as Category} />
      }
    >
      <CategoryPaper as="article">
        <header css={styles.header}>
          <Typography fontWeight="heavy" variant="h1">
            {article.headline}
          </Typography>
          {!isNil(article.shortAnswer) && (
            <ShortAnswer>{article.shortAnswer}</ShortAnswer>
          )}
          {article.showToc === true && <TableOfContent article={article} />}
        </header>
        <main css={styles.main}>
          <ArticleComponents components={article.contentSections} />
        </main>
      </CategoryPaper>
    </CategoryLayout>
  </>
)
